import { PriceOfferRow } from 'components/tables/data/price-offer/types';
import P2Medium from 'components/typography/P2Medium';

/**
 * Column for the organization name.
 */
export default function OrganizationColumn({ data }: { data: PriceOfferRow }) {
  return <P2Medium color="gray.8">{data.organization.organizationName}</P2Medium>;
}
